import AddEditProject from "@/apsales/Projects/AddEditProject";

export default function AddProject() {
    return <AddEditProject mode="add" />
}